import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SupPagesCardsComponent } from './sup-pages-cards/sup-pages-cards.component';
import { HeaderComponent } from './header/header.component'; 
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FooterComponent } from './footer/footer.component'; 


@NgModule({
  declarations: [
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  exports: [


    FooterComponent,
  ]
})
export class SharedModule { }
